import Box from "@ui-kit/layout/Box/Box.web";
import Link from "@ui-kit/navigation/Link/Link.web";
import CDNImage from "@ui-kit/media/CDNImage/CDNImage.web";
import { PropsWithChildren } from "react";

const AccountWrapper = ({ children }: PropsWithChildren) => {
  return (
    <Box display="flex" flexDirection="column" w="100%">
      <Box mb="xl" overflow="hidden">
        <Link href="/" display="block">
          <CDNImage
            useServerlessResize={false}
            src="images/logos/showpass-logo-red.svg"
            alt="showpass"
            width={140}
            height={40}
            style={{ objectFit: "contain" }}
          />
        </Link>
      </Box>
      {children}
    </Box>
  );
};

export default AccountWrapper;
